<template>
  <div class="filter_page">
    <div class="top-bg"></div>
    <div class="top-title">
      <div>
        <span>预约申请</span>
        <span>填写完整信息后进行预约</span>
      </div>
      <div>
        <img
          src="https://static.xchengtech.cn/5927dc560b8048dc87ede7a09c175670.png"
          alt=""
        />
      </div>
    </div>
    <div class="infoBox">
      <div class="qy_info">
        <div class="filter_title">
          <div>①</div>
          <div>企业信息</div>
        </div>
        <div class="companyNameOptionBox">
          <van-field
            class="companyName"
            @input="onCompanyNameChange"
            @clear="clearCompanyName"
            v-model="form.enterpriseName"
            placeholder="请填写"
            label="企业名称"
            clearable
          >
          </van-field>
          <div class="companyNameOption" v-show="companyNameOptionShow">
            <span
              @click="changeCompanyName(item)"
              v-for="(item, index) in companyNameOption"
              :key="index"
              >{{ item }}</span
            >
          </div>
        </div>
        <van-field
          v-model="form.accountType"
          label="账户性质"
          right-icon="arrow"
          placeholder="请选择"
          :readonly="true"
          @click="openSelect('accountType')"
          clearable
        />
      </div>

      <div class="qy_info">
        <div class="filter_title">
          <div>②</div>
          <div>银行信息</div>
        </div>
        <van-field
          v-model="form.region"
          label="地区"
          placeholder="请选择"
          right-icon="arrow"
          :readonly="true"
          @click="openSelect('region')"
          clearable
        />
        <van-field
          v-model="form.bankName"
          label="预约银行"
          placeholder="请选择"
          right-icon="arrow"
          :readonly="true"
          @click="openSelect('bankName')"
          clearable
        />
        <van-field
          v-model="form.bankBranch"
          label="预约网点"
          placeholder="请选择"
          right-icon="arrow"
          :readonly="true"
          @click="openSelect('bankBranch')"
          clearable
        />
      </div>

      <div class="qy_info">
        <div class="filter_title">
          <div>③</div>
          <div>预约信息</div>
        </div>
        <van-field
          class="companyName"
          v-model="form.contactName"
          placeholder="请填写"
          label="联系人姓名"
          clearable
        />
        <van-field
          class="companyName"
          v-model="form.contactMobile"
          placeholder="请填写"
          label="联系人手机"
          type="tel"
          clearable
        />
      </div>

      <div class="filter_button">
        <span @click="toPage('reservationRecord')">预约记录</span>
        <span @click="submit">提交</span>
      </div>
    </div>

    <van-popup position="bottom" v-model="showSelect">
      <van-picker
        title="请选择"
        show-toolbar
        :columns="columns"
        @confirm="onConfirm"
        @cancel="showSelect = !showSelect"
      />
    </van-popup>
  </div>
</template>

<script>
import { Field, Popup, Notify, Picker, Area, Dialog, Toast } from "vant";
import { getCurrentChannelInfo } from "@/api/login.js";
import { xcCompanySearch } from "@/api/xcCustomer";
import { xcBankAccSetup } from "@/api/reservation.js";
Vue.use(Field);
Vue.use(Notify);
import Vue from "vue";
export default {
  components: {},
  mounted() {},
  created() {
    // 获取渠道用户信息
    getCurrentChannelInfo().then((res) => {
      this.channelInfo = res;
      this.form.channelId = res.id;
    });
  },
  data() {
    return {
      form: {
        accountType: "",
        region: "",
        bankName: "",
        enterpriseName: "",
        contactName: "",
        bankBranch: "",
        contactMobile: "",
      },
      companyNameOption: [],
      companyNameOptionShow: false,
      showSelect: false,
      columnsType: "",
      columns: [],
      channelInfo: {},
    };
  },
  methods: {
    toPage(name) {
      this.$router.push({ path: "/" + name });
    },
    openSelect(type) {
      this.columnsType = type;
      if (type == "accountType") {
        this.columns = [
          { value: "基本存款账户", text: "基本存款账户" },
          { value: "一般存款账户", text: "一般存款账户" },
          { value: "其他存款账户", text: "其他存款账户" },
        ];
      }
      if (type == "region") {
        this.columns = [
          {
            text: "湖北省",
            children: [
              {
                text: "武汉市",
                children: [{ text: "江汉区" }],
              },
            ],
          },
        ];
      }
      if (type == "bankName") {
        if (!this.form.region) {
          Notify({ type: "danger", message: "请先选择地区" });
          return false;
        }
        this.columns = [{ value: "众邦银行", text: "众邦银行" }];
      }
      if (type == "bankBranch") {
        if (!this.form.region) {
          Notify({ type: "danger", message: "请先选择地区" });
          return false;
        }
        if (!this.form.bankName) {
          Notify({ type: "danger", message: "请先选择预约银行" });
          return false;
        }
        this.columns = [{ value: "众邦银行", text: "众邦银行" }];
      }
      this.showSelect = !this.showSelect;
    },
    onConfirm(e) {
      console.log("eee", e);
      if (this.columnsType == "region") {
        this.$set(this.form, this.columnsType, e.join("/"));
      } else {
        this.$set(this.form, this.columnsType, e.value);
      }
      this.showSelect = !this.showSelect;
    },
    submit() {
      if (!this.form.enterpriseName) {
        Notify({ type: "danger", message: "请填写企业名称" });
        return false;
      }
      if (!this.form.accountType) {
        Notify({ type: "danger", message: "请选择账户性质" });
        return false;
      }
      if (!this.form.region) {
        Notify({ type: "danger", message: "请选择地区" });
        return false;
      }
      if (!this.form.bankName) {
        Notify({ type: "danger", message: "请选择预约银行" });
        return false;
      }
      if (!this.form.bankBranch) {
        Notify({ type: "danger", message: "请选择预约网点" });
        return false;
      }
      if (!this.form.contactName) {
        Notify({ type: "danger", message: "请填写联系人姓名" });
        return false;
      }
      if (!this.form.contactMobile) {
        Notify({ type: "danger", message: "请填写联系人手机" });
        return false;
      }
      Toast.loading({
        duration: 0, // 持续展示 toast
        forbidClick: true,
        message: "加载中",
      });
      xcBankAccSetup(this.form)
        .then((res) => {
          Notify({ type: "success", message: "预约提交成功" });
          Toast.clear();
          this.$router.replace({
            name: "reservationRecord",
          });
        })
        .catch((err) => {
          Toast.clear();
          console.log("err", err);
        });
    },
    onCompanyNameChange(e) {
      // 输入字数大于3才会查询企业
      if (e.length > 3) {
        xcCompanySearch(e)
          .then((res) => {
            if (res && res[0]) {
              this.companyNameOption = res;
              this.companyNameOptionShow = true;
            }
          })
          .catch((err) => {
            console.log("err", err);
          });
      }
    },
    changeCompanyName(e) {
      this.form.enterpriseName = e;
      this.companyNameOptionShow = false;
    },
    clearCompanyName() {
      this.companyNameOptionShow = false;
      this.companyNameOption = [];
    },
  },
};
</script>
<style scoped src="./index.css"></style>



// WEBPACK FOOTER //
// src/view/reservation/index.vue